const STORY_MEDIA_PRECEDENCE = ["video", "audio", "image"];

const segmentTypeOf = segment => segment.segmentType ?? segment.segment_type;
const segmentIdOf = segment => segment.storySegmentId ?? segment.story_segment_id;

function orderedStorySegments(entity) {
  const segments = entity && entity.segments;
  const order = entity && entity.segmentOrder;
  if (!segments || !Array.isArray(order)) {
    return [];
  }
  const list = Object.values(segments);
  return order
      .map(item => list.find(segment => segmentIdOf(segment) === segmentIdOf(item)))
      .filter(Boolean);
}

function selectStoryMediaSegment(entity) {
  const ordered = orderedStorySegments(entity);
  for (const type of STORY_MEDIA_PRECEDENCE) {
    const match = ordered.find(segment => segmentTypeOf(segment) === type);
    if (match) {
      return match;
    }
  }
  return null;
}

function parseStorySegmentContent(segment) {
  if (!segment) {
    return null;
  }
  const raw = segment.segmentContent ?? segment.segment_content;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw && typeof raw === "object" ? raw : null;
}

function storyBodySegments(entity, { hideStoryMedia = false } = {}) {
  const ordered = orderedStorySegments(entity);
  if (!hideStoryMedia) {
    return ordered;
  }
  const media = selectStoryMediaSegment(entity);
  if (!media) {
    return ordered;
  }
  const hiddenId = segmentIdOf(media);
  return ordered.filter(segment => segmentIdOf(segment) !== hiddenId);
}

module.exports = {
  STORY_MEDIA_PRECEDENCE,
  segmentTypeOf,
  orderedStorySegments,
  selectStoryMediaSegment,
  parseStorySegmentContent,
  storyBodySegments,
};
